import http from './axios'
import config from './config'

let setting = null
let pending = null

// 平台系统设置走匿名接口，登录页、门户和管理端都要读，进程内只取一次
export function loadSysSetting(force = false) {
	if (setting && !force) return Promise.resolve(setting)
	if (pending && !force) return pending

	pending = http.get('api/sys/GetSystemSetting').then(res => {
		pending = null
		setting = res.data.code == 1 && res.data.data ? res.data.data : {}
		applyFavicon(setting.logo)
		return setting
	}).catch(() => {
		pending = null
		setting = setting || {}
		return setting
	})

	return pending
}

// 平台Logo只用于浏览器标签页图标
function applyFavicon(logo) {
	if (!logo) return
	let link = document.querySelector("link[rel~='icon']")
	if (!link) {
		link = document.createElement('link')
		link.rel = 'icon'
		document.head.appendChild(link)
	}
	link.href = config.fileurl + logo
}
